import { api } from 'boot/axios.js'

export async function save(ctx, data) {
  try {
    const response = await api({
      url: '/user-preferences',
      method: 'PUT',
      data
    })
    ctx.commit('item', response.data)
    return response
  } catch (e) {
    throw e
  }
}
